/**
 * Created by chenggong on 2018/3/30.
 */
import * as types from './mutation-types'

// 提交mutation
function makeAction (type) {
  return ({commit}, ...args) => commit(type, ...args)
}

// Token（测试用）
export const setToken = makeAction(types.SET_TOKEN)

// 用户基本信息
export const setUserInfo = makeAction(types.SET_USERINFO)

// 导航菜单
export const setNavMenu = makeAction(types.SET_NAVMENU)

// DashBroad
export const setDashBroad = makeAction(types.SET_DASHBROAD)

// SaleIndex
export const setSaleIndex = makeAction(types.SET_SALEINDEX)

// 部门列表
export const setDeptList = makeAction(types.SET_DEPTLIST)

// 商品主数据
export const setProductList = makeAction(types.SET_PRODUCTLIST)

// 销售分类列表
export const setSaleCategory = makeAction(types.SET_SALECATEGORY)

// 销售订单列表
export const setSaleOrderList = makeAction(types.SET_SALEORDERLIST)
export const setSaleOrderDetail = makeAction(types.SET_SALEORDERDETAIL)



// WEBPACK FOOTER //
// ./src/store/actions.js